import script from "./ConsultationWebDetailTmsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationWebDetailTmsComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__